import React from 'react';
import PropTypes from 'prop-types';
import PriceRangeInput from './PriceRangeInput';

function PriceRangeMax({ value, onChange, disabled, currency }) {
    const placeholder = currency ? `Price Range Max (${currency})` : 'Price Range Max';
    return (
        <PriceRangeInput
            value={value}
            onChange={onChange}
            disabled={disabled}
            placeholder={placeholder}
        />
    );
}

PriceRangeMax.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    currency: PropTypes.string
};

export default PriceRangeMax;



// WEBPACK FOOTER //
// ./src/js/modules/PriceRangeFilter/components/PriceRangeMax.js